import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'reviews',
        value: 'Reviews',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
      {
        key: 'reviewHighlights',
        value: 'Review Highlights',
      },
    ],
    links: 'appKey',
    default_value: 'reviews',
  },
  {
    type: 'html:attr',
    name: 'appKey',
    property: 'data-appkey',
    targetSelector: '.module>.yotpo',
    visible: 'field-hide-all',
    default_value: '',
    show: false,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * GpYotpoProductCollectionPage Atom Module
 */
export class GpYotpoProductCollectionPage extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Yotpo - Product &amp; Collection Page';
  }
  /**
   * override getSlug từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'yotpo-reviews';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
